/* eslint-disable @gandi/gandi/no-global-element */
// @flow
import * as React from 'react';

import clsx from 'clsx';
import { File, Upload } from 'lucide-react';

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useDragAndDrop } from './useDragAndDrop';

import styles from './CSVUploader.scss';

type Props = {
  setDomains: React.ReactSetStateFunction<string>,
  setError: React.ReactSetStateFunction<string>,
  setFileName: React.ReactSetStateFunction<string>,
};

export function CSVUploader({
  setDomains,
  setError,
  setFileName,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { isDragging, bind, handleFile } = useDragAndDrop({
    setDomains,
    setFileName,
    setError,
  });

  const handleFileChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    handleFile(e.target.files[0]);
  };

  const triggerFileInput = () => {
    const input = document.getElementById('csv-input');
    if (input) {
      input.click();
    }
  };

  return (
    <div
      className={clsx(styles.root, isDragging ? styles.isDragging : undefined)}
      {...bind}
    >
      <File size={24} />

      <p className={styles.text}>{__('Drop your .CSV files or')}</p>

      <input
        id="csv-input"
        type="file"
        accept=".csv"
        onChange={handleFileChange}
      />

      <Button type="button" onClick={triggerFileInput} disabled={isDragging}>
        <Upload size={16} />
        {__('Import your file')}
      </Button>
    </div>
  );
}
